<div class="row mb-3" *yatVar="subscriptionProduct$ | async as product">
  <div class="col-12">
    <yat-subscription-cancel-confirmation-text
      [productName]="product?.productLocalization?.productName ?? ''"
      [endOfPeriod]="(endOfPeriod$ | async) ?? undefined"
      [terminationDate]="(terminationDate$ | async) ?? undefined"
      [liveLicense]="(isLive$ | async) ?? true">
    </yat-subscription-cancel-confirmation-text>
  </div>
</div>
<button yat-button type="button" class="btn primary w-100" (click)="close()">
  {{ 'done' | commonWording | async }}
</button>
